import React, { createContext, useContext, useState } from 'react';

interface ParamContextType {
  querySearch: string;
  setQuerySearch: (value: string) => void;
}

const QuerySearchContext = createContext<ParamContextType | undefined>(
  undefined
);

export const QuerySearchProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [querySearch, setQuerySearch] = useState<string>('');

  return (
    <QuerySearchContext.Provider value={{ querySearch, setQuerySearch }}>
      {children}
    </QuerySearchContext.Provider>
  );
};

export const useQuerySearch = (): ParamContextType => {
  const context = useContext(QuerySearchContext);
  if (!context) {
    throw new Error('useQuerySearch must be used within a QuerySearchProvider');
  }
  return context;
};
